@use '../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;

:host {
  display: block;
}

.vs-bubblemarquee-container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  @include breakpoints.tablet-up{
    height: 600px !important;
  }
  @include breakpoints.desktop-up{
    height: 700px !important;
  }
  @include breakpoints.desktop-plus-up{
    height: 850px !important;
  }
  @include breakpoints.mobile{
    overflow: hidden;
  }
}

.vs-bubble-toggle-container {
  left: 0;
  right: 0;
  z-index: 3;
  pointer-events: none;

  @include breakpoints.tablet-up{
    position:absolute;
  }
}

.bubble-enabled {
  .vs-toggle-container {
    background: transparent !important;
    z-index: 3;
    position: relative;
  }

  .vs-toggle-wrapper {
    pointer-events: all;
  }


  @include breakpoints.mobile {
    .vs-toggle-container {
      padding-left: 20px ;
    }
  }
}
.vs-bubble-body{
  color: white !important;
  line-height: 25px !important;
}


.toggle-wrapper {
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 25px;
  display: flex;
  gap: 5px;
}

.toggle-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 20px;
  background: transparent;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-btn.active {
  background: white;
  color: #1434CB;
}

/* vs-bubble Section Styles */
.vs-bubble-section {
  display: flex;
  align-items: center;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

.vs-bubble-overlay{
  @include breakpoints.tablet-up{
    height: 600px !important;
    top:unset !important
  }
  @include breakpoints.desktop-up{
    height: 700px !important;
    top:unset !important
  }
  @include breakpoints.desktop-plus-up{
    height: 850px !important;
    top:unset !important
  }
  @include breakpoints.mobile{
    width: 100%;
    position: absolute;
    left: 0px;
    z-index: 1;
    opacity: .42;
    background-color: #000;
    background-color: var(--media-overlay-dark-bg-color)
  }
}

.vs-bubble-header{
  color: classic.$vs-white !important;
  color: white !important;
  padding-left: 25px;
  padding-right: 10px;

  @include breakpoints.mobile{
    padding-left:20px !important ;
  }
}

.vs-bubble-body{
  padding-left: 25px;
  padding-right: 10px;

  @include breakpoints.mobile{
    padding-left:20px !important ;
  }
}

.vs-bubble-content {
  color: white;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  opacity: 0;
  @include breakpoints.tablet-up{
    height: max-content !important;
    margin-top: auto;
    margin-bottom: auto;

  }
  @include breakpoints.desktop-up{
    height: max-content !important;
    }
  @include breakpoints.desktop-plus-up{
    height: max-content !important;
    }
}

.vs-bubble-eyebrow{
  color: white !important;
  line-height: 19px;
  padding-left: 25px !important;
  padding-right: 10px;

  @include breakpoints.mobile{
    padding-top:8px ;
    padding-left:20px !important ;
  }
}

.vs-bubble-content h1 {
  margin: 0;
  color: #fff;
}

.vs-bubble-content p {
  font-size: 1.1rem;
  opacity: 0.8;
  max-width: 400px;
  margin-top: 20px;
}

/* Add this new style for bubbles positioning */
.bubbles-container {
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
}

.vs-bubble-body .vs-text {
  color: white !important;
}

@include breakpoints.mobile {

  .vs-bubble-content {
    padding: 0;
    text-align: left;
    max-width: 100%;
  }

  .vs-bubble-content p {
    font-size: 1rem;
    margin-top: 20px;
    text-align: left;
    padding-right: 20px;
  }

  .vs-bubble-section {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
  }

  .vs-bubble-section-half {
    width: 100%;
  }

  .toggle-container {
    left: 20px;
    transform: none;
  }
}

@keyframes bubbleTextContentSlideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.vs-bubble-animate-up {
  animation: bubbleTextContentSlideUp 1.2s ease-out;
  opacity: 1;
}

/* Stagger animations */
.vs-bubble-content h1.vs-bubble-animate-up-item {
  animation-delay: 0.2s;
}

.vs-bubble-content p.vs-bubble-animate-up-item {
  animation-delay: 0.4s;
}

.vs-bubble-section-half.vs-bubble-animate-up-item {
  animation-delay: 0.6s;
}

.vs-bubble-marquee-content{
  margin-left:0px !important ;
  margin-right: 0px !important;
  @include breakpoints.tablet-up{
    height: 600px;
  }
  @include breakpoints.desktop-up{
    height: 700px;
  }
  @include breakpoints.desktop-plus-up{
    height: 850px;
  }
}